import React from 'react'
import { DossierStatusEnum } from '@services/constants/dossiers.constant'

export function getDossierTitleByOverview(
  overview: string,
  dossierNumber?: string,
  displayCommunication?: boolean,
): React.ReactNode {
  if(!displayCommunication) {
    const status = overview

    if (status === 'Création du dossier' && dossierNumber) {
      return (
        <>
          Le dossier <strong>{dossierNumber}</strong> a été créé pour votre requête.
        </>
      )
    }

    const allStatuses = Object.values(DossierStatusEnum)
    if (allStatuses.includes(status as DossierStatusEnum) || status === 'En attente de documents/informations') {
      return (
        <>
          Le statut du <strong>dossier</strong> a été modifié pour <strong>{status}</strong>.
        </>
      )
    }
  }
  
  return overview || ''
}
